import { jsx as _jsx } from "react/jsx-runtime";
// dev/app-skeleton/src/router.tsx
// UX D8 / R1 P0：客户端路由 + AppShell。
// D14-DEV-v2 / SEC C' 修：RequireUnlocked 智能跳转 /signup vs /unlock。
// D15 Task 3：新增 /forgot-password、/reset 公开路由。
// D15 Task 1：根组件挂载时 startSyncLoop()，覆盖"离线写 → 上线后没人 kick"场景。
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";
import { AppShell } from "./components/AppShell";
import { isUnlocked, onLockChange } from "./lib/session-key";
import { kvGet } from "./lib/db";
import { startSyncLoop } from "./lib/sync-client";
import { TodayPage } from "./pages/Today";
import { EntriesPage } from "./pages/Entries";
import { SearchPage } from "./pages/Search";
import { EntryEditorPage } from "./pages/EntryEditor";
import { SettingsPage } from "./pages/Settings";
import { SignupPage } from "./pages/Signup";
import { UnlockPage } from "./pages/Unlock";
import { ForgotPasswordPage } from "./pages/ForgotPassword";
import { ResetPage } from "./pages/Reset";
function RequireUnlocked() {
    const [ok, setOk] = useState(isUnlocked());
    const [hasAccount, setHasAccount] = useState(null);
    useEffect(() => onLockChange(setOk), []);
    useEffect(() => {
        let alive = true;
        kvGet("current_user_id").then((uid) => { if (alive)
            setHasAccount(!!uid); });
        return () => { alive = false; };
    }, [ok]);
    if (!ok) {
        if (hasAccount === null)
            return null;
        return _jsx(Navigate, { to: hasAccount ? "/unlock" : "/signup", replace: true });
    }
    return (_jsx(AppShell, { children: _jsx(Outlet, {}) }));
}
const router = createBrowserRouter([
    { path: "/signup", element: _jsx(SignupPage, {}) },
    { path: "/unlock", element: _jsx(UnlockPage, {}) },
    { path: "/forgot-password", element: _jsx(ForgotPasswordPage, {}) },
    { path: "/reset", element: _jsx(ResetPage, {}) },
    {
        element: _jsx(RequireUnlocked, {}),
        children: [
            { path: "/", element: _jsx(Navigate, { to: "/today", replace: true }) },
            { path: "/today", element: _jsx(TodayPage, {}) },
            { path: "/entries", element: _jsx(EntriesPage, {}) },
            { path: "/search", element: _jsx(SearchPage, {}) },
            { path: "/entry/new", element: _jsx(EntryEditorPage, {}) },
            { path: "/entry/:id", element: _jsx(EntryEditorPage, {}) },
            { path: "/settings", element: _jsx(SettingsPage, {}) },
        ],
    },
    { path: "*", element: _jsx(Navigate, { to: "/today", replace: true }) },
]);
export function Router() {
    // D15 Task 1：进程内只跑一次后台 sync loop。
    useEffect(() => {
        const stop = startSyncLoop(30_000);
        return stop;
    }, []);
    return _jsx(RouterProvider, { router: router });
}
